import { Component } from 'react';
import './index.less';

class Loading extends Component {
  render () {
    return (
      <div>
        <div className="box">页面加载中</div>
      </div>
    );
  }
}

export default Loading;
